/* eslint-disable @nx/enforce-module-boundaries */
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Box, Paper, Typography, Modal, IconButton, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/system';
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import refresh from 'packages/novous_web/src/assets/icons/Refresh.svg';
import CloseIcon from 'packages/novous_web/src/assets/icons/Close Square.svg';
import share from 'packages/novous_web/src/assets/icons/Share.svg';
import VideoPlayer from '../../../Trips/componenets/VideoPlayer';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import useAxios from 'packages/novous_web/src/api/useAxios';
import CameraButton from '../../../Trips/componenets/CameraButton';
import { multiSectionDigitalClockSectionClasses } from '@mui/x-date-pickers';
import MP4VideoPlayer from '../../../Trips/componenets/Mp4VideoPlayer';
import CallingModal from 'packages/novous_web/src/common/components/CallingModal';
import ShareSosFootageModal from 'packages/novous_web/src/common/components/ShareSosFootageModal';
import downloadWhiteIcon from 'packages/novous_web/src/assets/icons/downloadWhiteIcon.svg';
import FullscreenIcon from '@mui/icons-material/Fullscreen';
import FullscreenExitIcon from '@mui/icons-material/FullscreenExit';
import { bool } from 'aws-sdk/clients/signer';

type LiveFeedModalProps = {
  open: boolean;
  trip: any;
  selectedCameraName?: string;
  selectedCamera?: number;
  cameraInfo?: CameraProps[];
  type?: string;
  isDash?: boolean;
  alertName?: string;
  deviceId?: string;

  onClose: () => void;
  vehicleId?: string;
  videoPlayback?: boolean;
};

interface CameraProps {
  cameraId: string;
  cameraName: string;
  playBackUrl: string;
}

const LiveFeedModal: React.FC<LiveFeedModalProps> = ({
  open,
  selectedCameraName = '',
  isDash = false,
  selectedCamera = 0,
  alertName = '',
  cameraInfo = [],
  type = 'live',
  onClose,
  trip,
  deviceId,
  videoPlayback,
}) => {
  const theme = useTheme();
  const videoContainerRef = useRef<HTMLDivElement>(null);
  const loadingRef = useRef(true);
  const [isDeviceOffline, setDeviceOffline] = useState(false);
  const [totalVideos, setTotalVideos] = useState<CameraProps[]>([]);
  const [liveVideo, setLiveVideo] = useState<CameraProps[]>([]);
  const [selected, setSelected] = useState(selectedCamera);
  const [dimension, setDimension] = useState({ rowHeight: 0, rowWidth: 0 });
  const [callModalOpen, setCallModalOpen] = useState(false);
  const prevData = useRef(0);
  const [windowFullScreen, setWindowFullScreen] = useState(false);
  const [shareModalOpen, setShareModalOpen] = useState(false);
  const [Activelist, setActiveList] = useState<CameraProps[][]>([]);

  useEffect(() => {
    setSelected(selectedCamera);
  }, [selectedCamera]);

  const {
    data: liveStreamData,
    error: liveStreamError,
    loading: liveStreamLoading,
    fetchData: fetchLiveStreamData,
    resetData: resetLiveStreamData,
    errorStatus: liveStreamErrorStatus,
  } = useAxios<{ data: CameraProps[]; message: string }>(
    `${API_ENDPOINTS.dashboard.LIVE_STREAM}${!isDash ? trip?.vehicleRegNo : trip?.vehicleId}`,
    'GET',
  );

  let menuOptions: {
    name: string;
    click?: (cameraName: string) => void;
  }[] = [];

  if (Array.isArray(liveStreamData?.data) && liveStreamData.data.length > 0) {
    menuOptions = liveStreamData.data.map((item) => {
      return {
        name: item.cameraName,
        onClick: () => handleCameraSelect(item.cameraName),
      };
    });
  } else if (cameraInfo && type == 'alert') {
    loadingRef.current = false;
    menuOptions = cameraInfo.map((item) => {
      return {
        name: item.cameraName,
        onClick: () => handleCameraSelect(item.cameraName),
      };
    });
  }

  const handleCameraSelection = (name: string) => {
    if (type == 'alert') {
      if (name == 'All') {
        setSelected(0);
        setTotalVideos(cameraInfo);
      } else if (name == '2 Cam') {
        setSelected(2);
        const filterData = cameraInfo.filter((item, index) => index < 2);
        setTotalVideos(filterData);
      } else if (name == '4 Cam') {
        setSelected(4);
        const filterData = cameraInfo.filter((item, index) => index < 4);
        setTotalVideos(filterData);
      } else {
        setSelected(1);
      }
    } else {
      if (name == 'All') {
        setSelected(0);
        setTotalVideos(liveVideo);
      } else if (name == '2 Cam') {
        setSelected(2);
        const filterData = liveVideo.filter((item, index) => index < 2);
        setTotalVideos(filterData);
      } else if (name == '4 Cam') {
        setSelected(4);
        const filterData = liveVideo.filter((item, index) => index < 4);
        setTotalVideos(filterData);
      } else {
        setSelected(1);
      }
    }
  };

  const handleCalling = () => {
    setCallModalOpen(true);
  };

  const handleCameraSelect = (name: string) => {
    //console.info("name", name);
  };

  useEffect(() => {
    if (cameraInfo && type == 'alert') {
      setTotalVideos(cameraInfo);
    }
    if (selectedCameraName != '') {
      const filterData = cameraInfo.filter((item) => item.cameraName === selectedCameraName);
      //console.info(filterData, 'filterData');

      setTotalVideos(filterData);
    }
  }, [cameraInfo, selectedCameraName]);

  useEffect(() => {
    //console.info(trip, 'trip----------------');

    if (trip?.vehicleRegNo != '' && type == 'live' && open) {
      fetchLiveStreamData();
      loadingRef.current = true;
    }
  }, [trip?.vehicleRegNo, open]);

  useEffect(() => {
    let timeout: NodeJS.Timeout | undefined;

    const shouldProcess = Array.isArray(liveStreamData?.data) && type === 'live' && open;

    if (shouldProcess) {
      const streams = liveStreamData.data;
      const streamsWithoutPlayBack = streams.filter((item: any) => item.playBackUrl === '');

      const streamsWithPlayBack = streams.filter((item: any) => item.playBackUrl !== '');

      const hasStreams = streams.length > 0;
      const allStreamsReady = streamsWithoutPlayBack.length === 0;

      // console.info(
      //   "Streams fetched:",
      //   streams.length,
      //   "| Missing playBackUrl:",
      //   streamsWithoutPlayBack.length
      // );

      if (streamsWithPlayBack.length > 0 && prevData.current != streamsWithPlayBack.length) {
        prevData.current = streamsWithPlayBack.length;
        setTotalVideos([...streams]);
        setLiveVideo([...streams]);
        loadingRef.current = false;
      }

      // Retry fetching if not all streams are ready
      if (!allStreamsReady) {
        timeout = setTimeout(() => {
          //console.info("Retrying fetchLiveStreamData...");
          fetchLiveStreamData();
        }, 2000);
      } else {
        // ✅ All streams are ready, no need to retry further
        loadingRef.current = false;
        //console.info("All streams are ready, stopping retries.");
      }
    }

    if (liveStreamData?.message == 'Device Is not Online') {
      loadingRef.current = true;
      setDeviceOffline(true);
    }

    // Cleanup the timeout on component unmount or dependency change
    return () => {
      if (timeout) {
        clearTimeout(timeout);
        //console.info("Cleanup: timeout cleared");
      }
    };
  }, [liveStreamData, type, open]);

  const { rowArr, halfLength } = useMemo(() => {
    if (totalVideos.length === 0) return { rowArr: [], halfLength: 0 };

    let videos = [...totalVideos];

    // Ensuring even number of videos for grid layout
    if (videos.length > 2 && videos.length % 2 !== 0) {
      videos.push({
        cameraId: '',
        cameraName: '',
        playBackUrl: '',
      });
    }

    const half = Math.ceil(videos.length / 2);
    const firstRow = videos.slice(0, half);
    const secondRow = videos.slice(half);

    let rows: CameraProps[][];

    if (videos.length === 2) {
      rows = [videos];
    } else {
      rows = secondRow.length > 0 ? [firstRow, secondRow] : [firstRow];
    }

    return { rowArr: rows, halfLength: half };
  }, [totalVideos]);

  useEffect(() => {
    setActiveList(rowArr);
  }, [rowArr]);

  useEffect(() => {
    if (!open) return; // Wait for modal to open

    const timer = setTimeout(() => {
      if (videoContainerRef.current) {
        const containerHeight = videoContainerRef.current.offsetHeight;
        const containerWidth = videoContainerRef.current.offsetWidth;
        //console.info("Height:", containerHeight, "Width:", containerWidth);

        const rowHeight = rowArr.length === 2 ? containerHeight / 2 - 16 : containerHeight - 16;

        const rowWidth =
          totalVideos.length === 2
            ? containerWidth / 2 - 16
            : containerWidth / halfLength - halfLength * 8 - 8;

        setDimension({ rowHeight, rowWidth });
      }
    }, 100); // Add small delay to ensure DOM is painted

    return () => clearTimeout(timer);
  }, [open, rowArr.length, totalVideos.length, halfLength]);

  const handleCameraDropSelect = (cameraName: string, option: { name: string }) => {
    if (type == 'live') {
      const filterData = liveStreamData?.data.filter((item) => item.cameraName === option.name);
      setTotalVideos(filterData || []);
    } else {
      const filterData = cameraInfo.filter((item) => item.cameraName === option.name);
      setTotalVideos(filterData);
    }
    // You can do more with the selection here!
  };

  const handleRefresh = () => {
    if (trip?.vehicleRegNo != '' && type == 'live') fetchLiveStreamData();
    loadingRef.current = true;
  };

  const selectedOption = totalVideos.length > 0 ? totalVideos[0].cameraName : 'FCW';

  const handleDownload = async () => {
    const videoElement = document.querySelector('video');

    if (!videoElement) {
      //console.error("Video element not found");
      return;
    }

    const videoSrc = videoElement.src; // Get the video URL

    try {
      // Fetch the video as a Blob
      const response = await fetch(videoSrc);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      // Create a hidden anchor tag and trigger download
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = 'video.mp4'; // File name
      document.body.appendChild(link);
      link.click(); // Trigger click
      document.body.removeChild(link);

      // Clean up blob URL
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      //console.error("Error downloading video:", error);
    }
  };

  const [isFullscreen, setIsFullscreen] = useState(false);

  useEffect(() => {
    const handleFullscreenChange = () => {
      const fullscreenElement =
        document.fullscreenElement ||
        document.fullscreenElement ||
        document.fullscreenElement ||
        document.fullscreenElement;
      setIsFullscreen(!!fullscreenElement);
    };

    document.addEventListener('fullscreenchange', handleFullscreenChange);
    document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
    document.addEventListener('mozfullscreenchange', handleFullscreenChange);
    document.addEventListener('MSFullscreenChange', handleFullscreenChange);

    return () => {
      document.removeEventListener('fullscreenchange', handleFullscreenChange);
      document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.removeEventListener('mozfullscreenchange', handleFullscreenChange);
      document.removeEventListener('MSFullscreenChange', handleFullscreenChange);
    };
  }, [isFullscreen]);

  const handleFullScreen = (cameraId: string) => {
    const element = document.getElementById('stream-subcontainer');
    if (element) {
      const filterArr = Activelist.filter((item) => {
        const itemArr: CameraProps[] = item.filter((video) => {
          if (video.cameraId == cameraId) {
            return video;
          }
        });

        if (itemArr.length > 0) {
          setActiveList([itemArr]);
          return true;
        } else {
          return false;
        }
      });

      if (document.fullscreenElement) {
        document.exitFullscreen().then(() => {
          setWindowFullScreen(false);

          setActiveList(rowArr);
        });
      } else {
        element.requestFullscreen().then(() => {
          setWindowFullScreen(true);
        });
      }
    }
  };

  const handleFullClick = (video: any) => {
    handleFullScreen(video?.cameraId);
  };

  useEffect(() => {
    if (Activelist && windowFullScreen) {
      const containerHeight = window.innerHeight;
      const containerWidth = window.innerWidth;
      setDimension({ rowHeight: containerHeight, rowWidth: containerWidth });
    } else if (Activelist && !windowFullScreen) {
      setTimeout(() => {
        if (videoContainerRef.current) {
          const containerHeight = videoContainerRef.current.offsetHeight;
          const containerWidth = videoContainerRef.current.offsetWidth;

          const rowHeight = rowArr.length === 2 ? containerHeight / 2 - 16 : containerHeight - 16;

          const rowWidth =
            totalVideos.length === 2
              ? containerWidth / 2 - 16
              : containerWidth / halfLength - halfLength * 8 - 8;

          setDimension({ rowHeight, rowWidth });
        }
      }, 200);
    }
  }, [Activelist, windowFullScreen]);

  console.info('yashxx2');

  return (
    <>
      <Modal open={open} onClose={onClose}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: isFullscreen ? '100%' : '80%',
            height: isFullscreen ? '100%' : '80%',
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: isFullscreen ? 0 : 4,
            borderRadius: 2,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <Paper className="p-4 flex flex-col gap-4 h-full rounded-lg" sx={{ padding: 0 }}>
            {/* Header Section */}
            <div className="justify-between items-center" style={{ display: isFullscreen ? 'none' : 'flex' }}>
              <div className="flex flex-col">
                <Typography variant="h6">{type === `live` ? 'Live Feed Streaming ' : alertName}</Typography>
                <div className="flex gap-1">
                  <Typography variant="body2" color="secondary" fontWeight={400}>
                    {isDash ? 'Vehicle Reg No. :' : 'Trip ID:'}
                  </Typography>
                  <Typography variant="body2">
                    {isDash ? trip?.vehicleId || 'NA' : trip?.vehicleRegNo || trip?.tripId || 'NA'}
                  </Typography>
                </div>
              </div>
              <div className="flex gap-4">
                {type == 'live' && (
                  <>
                    <CustomIconButton
                      text="Refresh"
                      icon={<img src={refresh} alt="refresh" />}
                      background="transparent"
                      variant="outlined"
                      onClick={handleRefresh}
                    />
                    <CustomIconButton
                      text="2 way Communication"
                      outline
                      padding="0px"
                      variant="contained"
                      onClick={handleCalling}
                    />
                  </>
                )}
                {type == 'alert' && (
                  <>
                    <CustomIconButton
                      text="Share Footage"
                      outline
                      icon={<img src={share} alt="share" width={24} height={24} />}
                      padding="0px"
                      // variant="contained"
                      background="transparent"
                      variant="outlined"
                      onClick={() => setShareModalOpen(true)}
                    />

                    <CustomIconButton
                      icon={<img src={downloadWhiteIcon} alt="Add" width={16} height={16} />}
                      text="Download Footages"
                      variant="contained"
                      onClick={() => handleDownload()}
                    />
                  </>
                )}
                <IconButton sx={{ padding: '0px' }} onClick={onClose}>
                  <img src={CloseIcon} alt="CloseIcon" />
                </IconButton>
              </div>
            </div>

            {/* Video Player Grid - Ensuring max 2 rows */}
            <div
              className={`${
                isFullscreen
                  ? 'flex flex-col gap-4 overflow-y-scroll h-screen'
                  : 'flex flex-col gap-4 overflow-y-scroll h-full'
              } `}
              ref={videoContainerRef}
            >
              {loadingRef.current ? (
                <>
                  <div className="flex h-full justify-center items-center">
                    {liveStreamLoading && (
                      <Typography variant="h6" color="secondary">
                        Loading...
                      </Typography>
                    )}
                    {liveStreamErrorStatus === '500' && (
                      <Typography variant="h6">{liveStreamError}</Typography>
                    )}
                  </div>
                </>
              ) : (
                Activelist.map((row, rowIndex) => (
                  <div
                    key={rowIndex}
                    className={`${
                      isFullscreen
                        ? 'flex flex-col justify-center items-center h-screen gap-4'
                        : 'flex justify-center items-center h-full gap-4'
                    }`}
                    style={{ maxHeight: isFullscreen ? '100vh' : dimension.rowHeight }}
                  >
                    {row.length === 0 && (
                      <Typography variant="body2" color="secondary" fontWeight={600} fontSize={36}>
                        Video will be available soon
                      </Typography>
                    )}
                    {row.map(
                      (video, index) => (
                        console.info(video, 'videocheck'),
                        (
                          <>
                            <div className="relative">
                              {/* {index == 0 && rowIndex == 0 && (
                            <div
                              className="flex gap-2 absolute"
                              style={{ top: "4px", left: "4px", zIndex: 99 }}
                            >
                              <CameraButton
                                handleClick={handleCameraSelection}
                                isSelected={selected === 0}
                                name="All"
                              />
                              <CameraButton
                                handleClick={handleCameraSelection}
                                isSelected={selected === 1}
                                name={selectedOption}
                                options={menuOptions}
                                onSelect={handleCameraDropSelect}
                              />
                              <CameraButton
                                handleClick={handleCameraSelection}
                                isSelected={selected === 2}
                                name="2 Cam"
                              />
                              <CameraButton
                                handleClick={handleCameraSelection}
                                isSelected={selected === 4}
                                name="4 Cam"
                              />
                            </div>
                          )} */}
                              <div className="relative" id="stream-subcontainer">
                                {type == 'alert' && (
                                  <MP4VideoPlayer
                                    key={index}
                                    streamUrl={video.playBackUrl}
                                    availableHeight={dimension.rowHeight}
                                    availableWidth={dimension.rowWidth}
                                    fullMode={windowFullScreen}
                                    cameraList={Activelist}
                                    cameraId={cameraInfo[0]?.cameraId}
                                    deviceId={deviceId}
                                  />
                                )}
                                {type == 'live' && (
                                  <VideoPlayer
                                    key={index}
                                    streamUrl={video.playBackUrl}
                                    availableHeight={dimension.rowHeight}
                                    fullMode={windowFullScreen}
                                    cameraList={Activelist}
                                    availableWidth={dimension.rowWidth}
                                  />
                                )}
                                <IconButton
                                  color="primary"
                                  className={`absolute ${windowFullScreen ? 'right-[95px]' : 'right-[45px]'}`}
                                  size="small"
                                  onClick={() => {
                                    handleFullClick(video);
                                  }}
                                  style={{
                                    bottom: windowFullScreen ? '45px' : '30px',
                                    position: 'absolute',
                                    backgroundColor: 'white',
                                    color: '#333',
                                    zIndex: 100,
                                  }}
                                >
                                  {windowFullScreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
                                </IconButton>
                              </div>
                            </div>
                          </>
                        )
                      ),
                    )}
                  </div>
                ))
              )}
            </div>
          </Paper>
        </Box>
      </Modal>
      {type == 'live' && (
        <CallingModal tripInfo={trip} open={callModalOpen} onClose={() => setCallModalOpen(false)} />
      )}
      <ShareSosFootageModal
        open={shareModalOpen}
        onClose={() => setShareModalOpen(false)}
        shareLink={window.location.href}
        videoPlayback={videoPlayback}
        tripInfo={trip}
      />
    </>
  );
};

export default LiveFeedModal;
